<template>
    <main style="display: block;">
      <div class="scrollV" >
        <div style="padding: 1rem;" class="newFl">
            <transition name="view" appear>
                <div class="rowrapper">
                    <div class="div1">
                        <p style="font-size: .8rem; font-weight: 600; padding-left: 1rem;">Balance:</p>
                        <h2 style="font-size: 1.8rem; font-weight: 600; color: #2ECC71;" class="balH">
                            <sup>₦</sup>
                            {{ Intl.NumberFormat().format(balance.substring(0, balance.indexOf("."))) }}
                            <sub>.{{ balance.split('.')[1] }}</sub>
                        </h2>
                        <h3 class="bold-font" style="font-weight: 700; color: #196F3D; padding-left: 1rem;">Topup Airtime,</h3>
                        <h3 class="bold-font" style="font-weight: 700; color: #196F3D; padding-left: 1rem;">Buy Data,</h3>
                        <h3 class="bold-font" style="font-weight: 700; color: #196F3D; padding-left: 1rem;">Pay for Cable</h3>
                        <h3 class="bold-font" style="font-weight: 700; color: #196F3D; padding-left: 1rem;">&amp; Electricity</h3>
                    </div>
                    <div class="div2" style="backgound: #000000;">
                        <div class="page">

                            <label class="field field_v1">
                              <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="billChoice" @change="checkBillChoice">
                                <option value=""></option>
                                <option value="airtime">Airtime Purchase</option>
                                <option value="data">Data Purchase</option>
                                <option value="sme">SME Data Purchase</option>
                                <option value="spectranet-pin">Spectranet PIN Purchase</option>
                                <option value="smile">Smile Bundle Purchase</option>
                                <option value="cable">Cable Subscription</option>
                                <option value="electricity">Electricity Topup</option>
                                <option value="waec">WAEC</option>
                                <option value="jamb">JAMB</option>
                              </select>
                              <span class="field__label-wrap">
                              <span class="field__label">Choose Service</span>
                              </span>
                            </label>

                            <!-- Form for buying airtime -->
                            <form class="page3" @submit.prevent="openPinAirtimeModal" v-if="showAirtime">

                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="airtime.network">
                                  <option value=""></option>
                                  <option value="mtn">MTN</option>
                                  <option value="glo">GLO</option>
                                  <option value="airtel">Airtel</option>
                                  <option value="etisalat">9 Mobile</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                <span class="field__label">Choose Network</span>
                                </span>
                              </label>

                              <div>
                                <h6 style="width: 10%; float:left; padding-top: 1rem; color: #AAB7B8">+234</h6>
                                <label class="field field_v1" style="width: 90%; float:right;">
                                  <input class="field__input" type="tel" placeholder="e.g. 8012345678" v-model="airtime.phone" 
                                  pattern="[0-9]{10}" required>
                                  <span class="field__label-wrap">
                                    <span class="field__label">Phone Number</span>
                                  </span>
                                </label>
                              </div>

                              <label class="field field_v1">
                                <input class="field__input" type="number" min="50" placeholder="e.g. 1000" v-model="airtime.amount" required @input="checkInput">
                                <span class="field__label-wrap">
                                    <span class="field__label">Amount</span>
                                </span>
                              </label>

                              <h4 v-if="airtime.percAmount != null">Discounted Price: <del style="color: #E74C3C;">₦{{ Intl.NumberFormat().format(airtime.amount) }}</del> ₦{{ Intl.NumberFormat().format(airtime.percAmount) }}</h4>
                            
                              <Button class="w-50 px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light" round
                              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                                  <span style="text-align: center; font-weight: 600;" v-if="!isLoading">Buy Airtime</span>
                                  <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
                              </Button> 
                            </form>

                            <!-- Form for buying data -->
                            <form class="page3" @submit.prevent="openPinDataModal" v-if="showData">

                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="data.network" @change="checkNPChoice">
                                  <option value=""></option>
                                  <option v-for="(provider,index) in dataProviders" :key="index" :value="provider">{{ provider.name }}</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                <span class="field__label" v-if="!isLoadingFData">Choose Network</span>
                                <span class="field__label" v-if="isLoadingFData">Loading Providers</span>
                                </span>
                              </label>

                              <label class="field field_v1" v-if="data.network != '' && data.network != ' ' && data.network != null">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="data.variation_id" v-if="data.network.name == 'MTN'">
                                  <option value=""></option>
                                  <option v-for="(plan,index) in dataPlans" :key="index" :value="plan">{{ plan.duration }} @ ₦{{ plan.amount }}</option>
                                </select>
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="data.variation_id" v-if="data.network.name == '9MOBILE'">
                                  <option value=""></option>
                                  <option v-for="(plan,index) in dataPlans" :key="index" :value="plan">{{ plan.description }} @ ₦{{ plan.amount }}</option>
                                </select>
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="data.variation_id" v-if="data.network.name == 'AIRTEL'">
                                  <option value=""></option>
                                  <option v-for="(plan,index) in dataPlans" :key="index" :value="plan">{{ plan.description }}</option>
                                </select>
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="data.variation_id" v-if="data.network.name == 'GLO'">
                                  <option value=""></option>
                                  <option v-for="(plan,index) in dataPlans" :key="index" :value="plan">{{ plan.description }} Worth {{ plan.value }} at ₦{{ plan.amount }}</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                <span class="field__label" v-if="!isLoadingFDataBundles">Choose Plan</span> 
                                <span class="field__label" v-if="isLoadingFDataBundles">Loading Plans</span> 
                                </span>
                              </label>

                              <div>
                                <h6 style="width: 10%; float:left; padding-top: 1rem; color: #AAB7B8">+234</h6>
                                <label class="field field_v1" style="width: 90%; float:right;">
                                  <input class="field__input" type="tel" placeholder="e.g. 8012345678" v-model="data.phone" 
                                  pattern="[0-9]{10}" required>
                                  <span class="field__label-wrap">
                                    <span class="field__label">Phone Number</span>
                                  </span>
                                </label>
                              </div>

                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' '"><span>Discounted Price:</span> <del style="color: #E74C3C;">₦{{ Intl.NumberFormat().format(data.variation_id.price) }}</del> ₦{{ Intl.NumberFormat().format(data.variation_id.price - (data.variation_id.price * 0.01)) }}</h4>
                            
                              <Button class="w-50 px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light" round
                              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                                  <span style="text-align: center; font-weight: 600;" v-if="!isLoading">Buy Data</span>
                                  <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
                              </Button> 
                            </form>

                            <!-- Form for buying SME data -->
                            <form class="page3" @submit.prevent="openPinSMEModal" v-if="showSME">
                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;">
                                  <option value="MTN">MTN</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                <span class="field__label">Choose Network</span>
                                </span>
                              </label>

                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="data.variation_id">
                                  <option value=""></option>
                                  <option v-for="(plan,index) in dataPlans" :key="index" :value="plan">{{ plan.description }}</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                <span class="field__label" v-if="!isLoadingFDataBundles">Choose Plan</span> 
                                <span class="field__label" v-if="isLoadingFDataBundles">Loading Plans</span> 
                                </span>
                              </label>

                              <div>
                                <h6 style="width: 10%; float:left; padding-top: 1rem; color: #AAB7B8">+234</h6>
                                <label class="field field_v1" style="width: 90%; float:right;">
                                  <input class="field__input" type="tel" placeholder="e.g. 8012345678" v-model="data.phone" 
                                  pattern="[0-9]{10}" required>
                                  <span class="field__label-wrap">
                                    <span class="field__label">Phone Number</span>
                                  </span>
                                </label>
                              </div>

                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 500MB'">₦200</h4>
                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 1GB'">₦400</h4>
                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 2GB'">₦650</h4>
                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 3GB'">₦850</h4>
                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 5GB'">₦1,500</h4>
                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 10GB'">₦2,800</h4>

                              <Button class="w-50 px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light" round
                              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                                  <span style="text-align: center; font-weight: 600;" v-if="!isLoading">Buy Data</span>
                                  <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
                              </Button> 
                            </form>

                            <!-- Form for buying Spectranet PINs -->
                            <form class="page3" @submit.prevent="openPinSpectranetPinModal" v-if="showSpectranetPin">
                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;">
                                  <option value="SPECTRANET">SPECTRANET</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                <span class="field__label">Choose Network</span>
                                </span>
                              </label>

                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="data.variation_id">
                                  <option value=""></option>
                                  <option v-for="(plan,index) in dataPlans" :key="index" :value="plan">{{ plan.description }}</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                <span class="field__label" v-if="!isLoadingFDataBundles">Choose Plan</span> 
                                <span class="field__label" v-if="isLoadingFDataBundles">Loading Plans</span> 
                                </span>
                              </label>

                              <div>
                                <h6 style="width: 10%; float:left; padding-top: 1rem; color: #AAB7B8">+234</h6>
                                <label class="field field_v1" style="width: 90%; float:right;">
                                  <input class="field__input" type="tel" placeholder="e.g. 8012345678" v-model="data.phone" 
                                  pattern="[0-9]{10}" required>
                                  <span class="field__label-wrap">
                                    <span class="field__label">Phone Number</span>
                                  </span>
                                </label>
                              </div>

                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 500MB'">₦200</h4>
                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 1GB'">₦400</h4>
                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 2GB'">₦650</h4>
                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 3GB'">₦850</h4>
                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 5GB'">₦1,500</h4>
                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' ' && data.variation_id.description == 'SME DATA 10GB'">₦2,800</h4>

                              <Button class="w-50 px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light" round
                              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                                  <span style="text-align: center; font-weight: 600;" v-if="!isLoading">Buy Data</span>
                                  <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
                              </Button> 
                            </form>

                            <!-- Form for buying Smile data -->
                            <form class="page3" @submit.prevent="openPinSmileModal" v-if="showSmile">
                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;">
                                  <option value="SMILE">Smile</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                <span class="field__label">Choose Network</span>
                                </span>
                              </label>

                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="data.variation_id">
                                  <option value=""></option>
                                  <option v-for="(plan,index) in dataPlans" :key="index" :value="plan">{{ plan.description }} @ ₦{{ plan.amount }}</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                <span class="field__label" v-if="!isLoadingFDataBundles">Choose Plan</span> 
                                <span class="field__label" v-if="isLoadingFDataBundles">Loading Plans</span> 
                                </span>
                              </label>

                              <div>
                                <h6 style="width: 10%; float:left; padding-top: 1rem; color: #AAB7B8">+234</h6>
                                <label class="field field_v1" style="width: 90%; float:right;">
                                  <input class="field__input" type="tel" placeholder="e.g. 8012345678" v-model="data.phone" 
                                  pattern="[0-9]{10}" required>
                                  <span class="field__label-wrap">
                                    <span class="field__label">Phone Number</span>
                                  </span>
                                </label>
                              </div>

                              <h4 style="text-align: center" v-if="data.variation_id != null && data.variation_id != '' && data.variation_id != ' '"><span>Discounted Price:</span> <del style="color: #E74C3C;">₦{{ Intl.NumberFormat().format(data.variation_id.amount) }}</del> ₦{{ Intl.NumberFormat().format(data.variation_id.amount - (data.variation_id.amount * 0.01)) }}</h4>

                              <Button class="w-50 px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light" round
                              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                                  <span style="text-align: center; font-weight: 600;" v-if="!isLoading">Buy Data</span>
                                  <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
                              </Button> 
                            </form>

                            <!-- Form for subscribing for cable -->
                            <form class="page3" @submit.prevent="openPinCableModal" v-if="showCable">

                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="cable.provider" @change="checkCPChoice">
                                  <option value=""></option>
                                  <option v-for="(provider,index) in cableProviders" :key="index" :value="provider">{{ provider.name }}</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                  <span class="field__label" v-if="!isLoadingFData">Choose Cable</span>
                                  <span class="field__label" v-if="isLoadingFData">Loading Cables</span>
                                </span>
                              </label>

                              <label class="field field_v1" v-if="cable.provider != '' && cable.provider != ' ' && cable.provider != null">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="cable.plan">
                                  <option value=""></option>
                                  <option v-for="(plan,index) in cablePlans" :key="index" :value="plan">{{ plan.name }} at ₦{{ plan.price }}</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                  <span class="field__label" v-if="!isLoadingFDataBundles">Choose Plan</span>
                                  <span class="field__label" v-if="isLoadingFDataBundles">Loading Plans</span>
                                </span>
                              </label>

                              <div>
                                <h6 style="width: 10%; float:left; padding-top: 1rem; color: #AAB7B8">+234</h6>
                                <label class="field field_v1" style="width: 90%; float:right;">
                                  <input class="field__input" type="tel" placeholder="e.g. 8012345678" v-model="cable.phone" 
                                  pattern="[0-9]{10}" required>
                                  <span class="field__label-wrap">
                                    <span class="field__label">Phone Number</span>
                                  </span>
                                </label>
                              </div>
                              
                              <label class="field field_v1">
                                <input class="field__input" type="number" placeholder="e.g. 7032400086" v-model="cable.smartcard_number" required>
                                <span class="field__label-wrap">
                                    <span class="field__label">SmartCard Number</span>
                                </span>
                              </label>

                              <h4 style="text-align: center" v-if="cable.plan != null && cable.plan != '' && cable.plan != ' '">₦{{ Intl.NumberFormat().format(cable.plan.price) }}</h4>
                            
                              <Button class="w-50 px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light" round
                              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                                  <span style="text-align: center; font-weight: 600;" v-if="!isLoading">Subscribe Cable</span>
                                  <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
                              </Button> 
                            </form>

                            <!-- Form for buying electricity -->
                            <form class="page3" @submit.prevent="openPinElecModal" v-if="showElec">

                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="elec.provider">
                                  <option value=""></option>
                                  <option v-for="(provider,index) in elecProviders" :key="index" :value="provider">{{ provider.short_name.toUpperCase() }}</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                  <span class="field__label" v-if="!isLoadingFData">Choose Distro</span>
                                  <span class="field__label" v-if="isLoadingFData">Loading Distros</span>
                                </span>
                              </label>

                              <div>
                                <h6 style="width: 10%; float:left; padding-top: 1rem; color: #AAB7B8">+234</h6>
                                <label class="field field_v1" style="width: 90%; float:right;">
                                  <input class="field__input" type="tel" placeholder="e.g. 8012345678" v-model="elec.phone" 
                                  pattern="[0-9]{10}" required>
                                  <span class="field__label-wrap">
                                    <span class="field__label">Phone Number</span>
                                  </span>
                                </label>
                              </div>
                              
                              <label class="field field_v1">
                                <input class="field__input" type="number" placeholder="e.g. 62418234034" v-model="elec.meter_number" required>
                                <span class="field__label-wrap">
                                    <span class="field__label">Meter Number</span>
                                </span>
                              </label>

                              <label class="field field_v1">
                                <input class="field__input" type="number" min="500" placeholder="e.g. 1000" v-model="elec.amount" required>
                                <span class="field__label-wrap">
                                    <span class="field__label">Amount</span>
                                </span>
                              </label>
                            
                              <Button class="w-50 px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light" round
                              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                                  <span style="text-align: center; font-weight: 600;" v-if="!isLoading">Pay Electricity</span>
                                  <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
                              </Button> 
                            </form>

                            <!-- Form for buying waec pins -->
                            <form class="page3" @submit.prevent="openPinWaecModal" v-if="showWaec">
                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="waec.plan">
                                  <option value=""></option>
                                  <option v-for="(plan,index) in waecPlans" :key="index" :value="plan">₦{{ Intl.NumberFormat().format(plan.price) }}</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                  <span class="field__label" v-if="!isLoadingFData">Choose Plan</span>
                                  <span class="field__label" v-if="isLoadingFData">Loading Plans</span>
                                </span>
                              </label>

                              <label class="field field_v1">
                                <input class="field__input" type="number" placeholder="e.g. 3" min="1" v-model="waec.numberOfPin" required>
                                <span class="field__label-wrap">
                                    <span class="field__label">Number of PINs</span>
                                </span>
                              </label>

                              <Button class="w-50 px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light" round
                              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                                  <span style="text-align: center; font-weight: 600;" v-if="!isLoading">Purchase PIN</span>
                                  <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
                              </Button> 
                            </form>

                            <!-- Form for buying jamb pins -->
                            <form class="page3" @submit.prevent="openPinJambModal" v-if="showJamb">
                              <label class="field field_v1">
                                <select class="field__input" style="display: inline-block; padding-bottom: .2rem;" v-model="jamb.plan">
                                  <option value=""></option>
                                  <option v-for="(plan,index) in jambPlans" :key="index" :value="plan">{{ plan.type }} @ ₦{{ Intl.NumberFormat().format(plan.price) }}</option>
                                </select>
                                <!-- <svg style="display: inline-block;" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg> -->
                                <span class="field__label-wrap">
                                  <span class="field__label" v-if="!isLoadingFData">Choose Plan</span>
                                  <span class="field__label" v-if="isLoadingFData">Loading Plans</span>
                                </span>
                              </label>

                              <div>
                                <h6 style="width: 10%; float:left; padding-top: 1rem; color: #AAB7B8">+234</h6>
                                <label class="field field_v1" style="width: 90%; float:right;">
                                  <input class="field__input" type="tel" placeholder="e.g. 8012345678" v-model="jamb.phone" 
                                  pattern="[0-9]{10}" required>
                                  <span class="field__label-wrap">
                                    <span class="field__label">Phone Number</span>
                                  </span>
                                </label>
                              </div>

                              <label class="field field_v1">
                                <input class="field__input" type="text" placeholder="e.g. 2222222222" v-model="jamb.profileCode" required>
                                <span class="field__label-wrap">
                                    <span class="field__label">Profile Code</span>
                                </span>
                              </label>

                              <Button class="w-50 px-4 py-2 h-10 bg-green-normal text-white hover:bg-green-light" round
                              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                                  <span style="text-align: center; font-weight: 600;" v-if="!isLoading">Purchase PIN</span>
                                  <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
                              </Button> 
                            </form>
                            
                        </div>
                    </div>
                </div>
            </transition>
        </div>
      </div>
      <modal name="pinAirtimeModal" :clickToClose="false" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
        <button @click="closePinAirtimeModal" style="float: right; padding: 1rem;">
          ❌
        </button>
        <div class="tvv2">
          <div>
            <img src="../../assets/img/icons/lock.svg" alt="" class="qrClass">
            <h3 class="bold-font" style="color: #0E6655; font-size: 25px; padding-top: 1rem;">Confirm Zinger PIN</h3>
            <h4 style="padding-top: .5rem;">Enter your 4-digit Zinger PIN to complete</h4>
            <form class="page2" @submit.prevent="checkPinAirtime">
              <div class="qrClass" style="padding-top: 2rem;">
                <PincodeInput
                  v-model="pinCode"
                  placeholder="0"
                  :secure="true"
                />
              </div>

              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center; font-weight: 800;" v-if="!isLoadingConPayWB">Confirm</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingConPayWB">
              </Button> 
            </form>
            <h4 style="padding-top: .2rem;">Forgot PIN? <a href="https://zingerwallet.com/support" id="ahov" target="__blank">Contact Support</a></h4>
          </div>
        </div>
      </modal>
      <modal name="pinDataModal" :clickToClose="false" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
        <button @click="closePinDataModal" style="float: right; padding: 1rem;">
          ❌
        </button>
        <div class="tvv2">
          <div>
            <img src="../../assets/img/icons/lock.svg" alt="" class="qrClass">
            <h3 class="bold-font" style="color: #0E6655; font-size: 25px; padding-top: 1rem;">Confirm Zinger PIN</h3>
            <h4 style="padding-top: .5rem;">Enter your 4-digit Zinger PIN to complete</h4>
            <form class="page2" @submit.prevent="checkPinData">
              <div class="qrClass" style="padding-top: 2rem;">
                <PincodeInput
                  v-model="pinCode"
                  placeholder="0"
                  :secure="true"
                />
              </div>

              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center; font-weight: 800;" v-if="!isLoadingConPayWB">Confirm</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingConPayWB">
              </Button> 
            </form>
            <h4 style="padding-top: .2rem;">Forgot PIN? <a href="https://zingerwallet.com/support" id="ahov" target="__blank">Contact Support</a></h4>
          </div>
        </div>
      </modal>
      <modal name="pinSMEModal" :clickToClose="false" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
        <button @click="closePinSMEModal" style="float: right; padding: 1rem;">
          ❌
        </button>
        <div class="tvv2">
          <div>
            <img src="../../assets/img/icons/lock.svg" alt="" class="qrClass">
            <h3 class="bold-font" style="color: #0E6655; font-size: 25px; padding-top: 1rem;">Confirm Zinger PIN</h3>
            <h4 style="padding-top: .5rem;">Enter your 4-digit Zinger PIN to complete</h4>
            <form class="page2" @submit.prevent="checkPinSME">
              <div class="qrClass" style="padding-top: 2rem;">
                <PincodeInput
                  v-model="pinCode"
                  placeholder="0"
                  :secure="true"
                />
              </div>

              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center; font-weight: 800;" v-if="!isLoadingConPayWB">Confirm</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingConPayWB">
              </Button> 
            </form>
            <h4 style="padding-top: .2rem;">Forgot PIN? <a href="https://zingerwallet.com/support" id="ahov" target="__blank">Contact Support</a></h4>
          </div>
        </div>
      </modal>
      
      <modal name="pinSmileModal" :clickToClose="false" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
        <button @click="closePinSmileModal" style="float: right; padding: 1rem;">
          ❌
        </button>
        <div class="tvv2">
          <div>
            <img src="../../assets/img/icons/lock.svg" alt="" class="qrClass">
            <h3 class="bold-font" style="color: #0E6655; font-size: 25px; padding-top: 1rem;">Confirm Zinger PIN</h3>
            <h4 style="padding-top: .5rem;">Enter your 4-digit Zinger PIN to complete</h4>
            <form class="page2" @submit.prevent="checkPinSmile">
              <div class="qrClass" style="padding-top: 2rem;">
                <PincodeInput
                  v-model="pinCode"
                  placeholder="0"
                  :secure="true"
                />
              </div>

              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center; font-weight: 800;" v-if="!isLoadingConPayWB">Confirm</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingConPayWB">
              </Button> 
            </form>
            <h4 style="padding-top: .2rem;">Forgot PIN? <a href="https://zingerwallet.com/support" id="ahov" target="__blank">Contact Support</a></h4>
          </div>
        </div>
      </modal>
      <modal name="pinCableModal" :clickToClose="false" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
        <button @click="closePinCableModal" style="float: right; padding: 1rem;">
          ❌
        </button>
        <div class="tvv2">
          <div>
            <img src="../../assets/img/icons/lock.svg" alt="" class="qrClass">
            <h3 class="bold-font" style="color: #0E6655; font-size: 25px; padding-top: 1rem;">Confirm Zinger PIN</h3>
            <h4 style="padding-top: .5rem;">Enter your 4-digit Zinger PIN to complete</h4>
            <form class="page2" @submit.prevent="checkPinCable">
              <div class="qrClass" style="padding-top: 2rem;">
                <PincodeInput
                  v-model="pinCode"
                  placeholder="0"
                  :secure="true"
                />
              </div>

              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center; font-weight: 800;" v-if="!isLoadingConPayWB">Confirm</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingConPayWB">
              </Button> 
            </form>
            <h4 style="padding-top: .2rem;">Forgot PIN? <a href="https://zingerwallet.com/support" id="ahov" target="__blank">Contact Support</a></h4>
          </div>
        </div>
      </modal>
      <modal name="pinElecModal" :clickToClose="false" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
        <button @click="closePinElecModal" style="float: right; padding: 1rem;">
          ❌
        </button>
        <div class="tvv2">
          <div>
            <img src="../../assets/img/icons/lock.svg" alt="" class="qrClass">
            <h3 class="bold-font" style="color: #0E6655; font-size: 25px; padding-top: 1rem;">Confirm Zinger PIN</h3>
            <h4 style="padding-top: .5rem;">Enter your 4-digit Zinger PIN to complete</h4>
            <form class="page2" @submit.prevent="checkPinElec">
              <div class="qrClass" style="padding-top: 2rem;">
                <PincodeInput
                  v-model="pinCode"
                  placeholder="0"
                  :secure="true"
                />
              </div>

              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center; font-weight: 800;" v-if="!isLoadingConPayWB">Confirm</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingConPayWB">
              </Button> 
            </form>
            <h4 style="padding-top: .2rem;">Forgot PIN? <a href="https://zingerwallet.com/support" id="ahov" target="__blank">Contact Support</a></h4>
          </div>
        </div>
      </modal>
      <modal name="pinWaecModal" :clickToClose="false" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
        <button @click="closePinWaecModal" style="float: right; padding: 1rem;">
          ❌
        </button>
        <div class="tvv2">
          <div>
            <img src="../../assets/img/icons/lock.svg" alt="" class="qrClass">
            <h3 class="bold-font" style="color: #0E6655; font-size: 25px; padding-top: 1rem;">Confirm Zinger PIN</h3>
            <h4 style="padding-top: .5rem;">Enter your 4-digit Zinger PIN to complete</h4>
            <form class="page2" @submit.prevent="checkPinWaec">
              <div class="qrClass" style="padding-top: 2rem;">
                <PincodeInput
                  v-model="pinCode"
                  placeholder="0"
                  :secure="true"
                />
              </div>

              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center; font-weight: 800;" v-if="!isLoadingConPayWB">Confirm</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingConPayWB">
              </Button> 
            </form>
            <h4 style="padding-top: .2rem;">Forgot PIN? <a href="https://zingerwallet.com/support" id="ahov" target="__blank">Contact Support</a></h4>
          </div>
        </div>
      </modal>
      
      <modal name="pinJambModal" :clickToClose="false" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
        <button @click="closePinJambModal" style="float: right; padding: 1rem;">
          ❌
        </button>
        <div class="tvv2">
          <div>
            <img src="../../assets/img/icons/lock.svg" alt="" class="qrClass">
            <h3 class="bold-font" style="color: #0E6655; font-size: 25px; padding-top: 1rem;">Confirm Zinger PIN</h3>
            <h4 style="padding-top: .5rem;">Enter your 4-digit Zinger PIN to complete</h4>
            <form class="page2" @submit.prevent="checkPinJamb">
              <div class="qrClass" style="padding-top: 2rem;">
                <PincodeInput
                  v-model="pinCode"
                  placeholder="0"
                  :secure="true"
                />
              </div>

              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center; font-weight: 800;" v-if="!isLoadingConPayWB">Confirm</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingConPayWB">
              </Button> 
            </form>
            <h4 style="padding-top: .2rem;">Forgot PIN? <a href="https://zingerwallet.com/support" id="ahov" target="__blank">Contact Support</a></h4>
          </div>
        </div>
      </modal>
      
    </main>
</template>

<script> 
  // import axios from "axios";
  import axios from '../../AxiosInstance.js';
  import router from "../../router";
  import Button from "../../components/Button";
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';
  import PincodeInput from 'vue-pincode-input';

  var utc = require('dayjs/plugin/utc')
  var timezone = require('dayjs/plugin/timezone');

  dayjs.extend(utc);
  dayjs.extend(timezone);

  export default {
    name: 'send',
    components: {
      Button,
      PincodeInput
    },
    data() {
      return {
        url: process.env.VUE_APP_BASE_URL,
        nodeurl: process.env.VUE_APP_NODE_URL,
        provi_url: process.env.VUE_APP_PROVIDUS_VTU_ENDPOINT,
        is_staff: localStorage.getItem("on_business_name") ? true : false,
        balance: localStorage.getItem("balance"),
        token: this.decrypt(localStorage.getItem("token")),
        user_id: this.decrypt(localStorage.getItem("user_id")),
        profile_id: this.decrypt(localStorage.getItem("profile_id")),
        has_signatory: this.decrypt(localStorage.getItem("has_signatory")),
        buttonType: 'submit', 
        isLoading: false,
        isLoadingUsers: false,
        isDisabled: true,
        decData: {},
        sendAmount: null,
        recepient: null,
        nfo: false,
        showClear: false,
        signatories: [],
        mainRecData: {},
        busRecData: {},
        staffRecData: {},
        options: [],
        staffOptions: [],
        fullVAmount: null,
        isLoadingVouchers: false,
        isLoadingConPayWB: false,
        vouchers: [],
        voucherDetails: {},
        pinCode: '',
        saveBen: false,

        isLoadingFData: false,
        isLoadingFDataBundles: false,
        billChoice: null,
        showAirtime: false,
        showData: false,
        showCable: false,
        showElec: false,
        showSME: false,
        showSpectranetPin: false,
        showSmile: false,
        showWaec: false,
        showJamb: false,
        airtime: {phone: localStorage.getItem("phone").slice(3), percAmount: null,},
        data: {phone: localStorage.getItem("phone").slice(3),},
        dataProviders: [],
        dataPlans: [],
        cable: {phone: localStorage.getItem("phone").slice(3),},
        cableProviders: [],
        cablePlans: [],
        elec: {phone: localStorage.getItem("phone").slice(3),},
        elecProviders: [],
        waec: {},
        waecPlans: [],
        jamb: {},
        jambPlans: []
      }
    },
    mounted() {
      this.checkLoggedIn();
    },
    created() {
      document.title = "Zinger - Bills";
      dayjs.extend(relativeTime);
    },
    filters: {
      diffForHumans: (date) => {
        if (!date){
            return null;
        }
        return dayjs.tz(date,"Europe/London").fromNow();
      },
      dateFor: (date) => {
        date = date.substring(0, date.indexOf("."))
        return dayjs(date).format('ddd, MMM D, YYYY h:mm A');
      }
    },
    methods: {
      checkLoggedIn() {
        if(!this.is_staff){
            if (!this.token) {
                router.push({ name: "login", query: { redirect: "/bills" } });
            }else if(this.decrypt(localStorage.getItem("verified_status")) == 'false'){
                router.push("/verify");
            }else if(localStorage.getItem("is_business") == 'false'){
                if(this.decrypt(localStorage.getItem("reached_limit")) == 'true' && localStorage.getItem("is_upgraded") == 'false'){
                    router.push("/upgrade");
                }else{
                  this.getSignatories();
                }
                //
            }else{
                this.getSignatories();
                //
            }
        }else{
            router.push("/");
        }
      },
      getCats(){
        let info = {}
        axios.post(this.nodeurl + "bill-categories", info).then(response => {
          // this.signatories = response.data;
          console.log(response.data)
        }).catch(err => {
          console.log(err)
        });
      },
      getSignatories(){
        if(this.has_signatory == 'true'){
          axios.get(this.url + "api/v1/signatories-bus/" + this.user_id + "/",
          { headers: { authorization: "Token " + this.token } }).then(response => {
            this.signatories = response.data;
            // console.log(response.data)
          }).catch(err => {
            // console.log(err)
          });
        }
      },
      checkBillChoice(){
        if(this.billChoice == "airtime"){
          this.showAirtime = true;
          this.showData = false;
          this.showCable = false;
          this.showElec = false; 
          this.showSME = false;
          this.showSpectranetPin = false;
          this.showSmile = false;
        }else if(this.billChoice == "data"){
          this.showData = true;
          this.showAirtime = false;
          this.showCable = false;
          this.showElec = false; 
          this.showSME = false;
          this.showSpectranetPin = false;
          this.showSmile = false;
          this.fetchDataProviders();
        }else if(this.billChoice == "sme"){
          this.showSME = true;
          this.showData = false;
          this.showAirtime = false;
          this.showCable = false;
          this.showElec = false; 
          this.showSpectranetPin = false;
          this.showSmile = false;
          this.fetchSMEPlans();
        }else if(this.billChoice == "spectranet-pin"){
          this.showSpectranetPin = true;
          this.showSME = false;
          this.showData = false;
          this.showAirtime = false;
          this.showCable = false;
          this.showElec = false; 
          this.showSmile = false;
          this.fetchSpectranetPinPlans();
        }else if(this.billChoice == "smile"){
          this.showSmile = true;
          this.showSpectranetPin = false;
          this.showSME = false;
          this.showData = false;
          this.showAirtime = false;
          this.showCable = false;
          this.showElec = false; 
          this.fetchSmilePlans();
        }else if(this.billChoice == "cable"){
          this.showCable = true;
          this.showAirtime = false;
          this.showData = false;
          this.showElec = false; 
          this.showSME = false;
          this.showSpectranetPin = false;
          this.showSmile = false;
          this.fetchCableProviders();
        }else if(this.billChoice == "electricity"){
          this.showElec = true;
          this.showAirtime = false;
          this.showData = false;
          this.showCable = false; 
          this.showSME = false;
          this.showSpectranetPin = false;
          this.showSmile = false;
          this.fetchElectricityProviders();
        }else if(this.billChoice == "waec"){
          this.showWaec = true;
          this.showElec = false;
          this.showAirtime = false;
          this.showData = false;
          this.showCable = false; 
          this.showSME = false;
          this.showSpectranetPin = false;
          this.showSmile = false;
          this.showJamb = false;
          this.fetchWaecPlans();
        }else if(this.billChoice == "jamb"){
          this.showJamb = true;
          this.showElec = false;
          this.showAirtime = false;
          this.showData = false;
          this.showCable = false; 
          this.showSME = false;
          this.showSpectranetPin = false;
          this.showSmile = false;
          this.showWaec = false;
          this.fetchJambPlans();
        }else{
          this.showElec = false;
          this.showAirtime = false;
          this.showData = false;
          this.showCable = false; 
          this.showSME = false;
          this.showSpectranetPin = false;
          this.showSmile = false;
        }
      },
      checkNPChoice(){
        let info = {'provider': this.data.network};
        this.isLoadingFDataBundles = true;
        axios.post(this.nodeurl + "fetch-data-bundles", info).then(message => {
          this.isLoadingFDataBundles = false;
          this.dataPlans = message.data.message.data;
          console.log(this.dataPlans)
        }).catch(err => {
          this.isLoadingFDataBundles = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
        // if(this.data.network == "mtn"){
        //   this.dataPlans = [
        //     {value: '500', name: 'MTN Data 500MB (SME) – 30 Days', price: '190', appr: '200'},
        //     {value: 'M1024', name: 'MTN Data 1GB (SME) – 30 Days', price: '400', appr: '1000'},
        //     {value: 'M2024', name: 'MTN Data 2GB (SME) – 30 Days', price: '600', appr: '1200'},
        //     {value: '3000', name: 'MTN Data 3GB (SME) – 30 Days', price: '850', appr: '1500'},
        //     {value: '5000', name: 'MTN Data 5GB (SME) – 30 Days', price: '1500', appr: '2000'},
        //     {value: 'mtn-20hrs-1500', name: 'MTN Data 6GB (Direct) – 7 Days', price: '1495', appr: '1500'},
        //     {value: '10000', name: 'MTN Data 10GB (SME) – 30 Days', price: '2900', appr: '3000'},
        //     {value: 'GIFT5000', name: 'MTN Data 20GB (Direct) – 30 Days', price: '5000', appr: null},
        //     {value: 'mtn-30gb-8000', name: 'MTN Data 30GB (Direct) – 30 Days', price: '8000', appr: '9000'},
        //     {value: 'mtn-40gb-10000', name: 'MTN Data 40GB (Direct) – 30 Days', price: '9900', appr: '10000'},
        //     {value: 'mtn-75gb-10000', name: 'MTN Data 75GB (Direct) – 30 Days', price: '15000', appr: null},
        //   ];
        // }else if(this.data.network == "glo"){
        //   this.dataPlans = [
        //     {value: 'glo100x', name: 'Glo Data 1GB – 5 Nights', price: '100', appr: null},
        //     {value: 'glo200x', name: 'Glo Data 1.25GB – 1 Day (Sunday)', price: '200', appr: null},
        //     {value: 'G500', name: 'Glo Data 1.35GB – 14 Days', price: '490', appr: '500'},
        //     {value: 'G1000', name: 'Glo Data 2.9GB – 30 Days', price: '990', appr: '1000'},
        //     {value: 'G2000', name: 'Glo Data 5.8GB – 30 Days', price: '1980', appr: '2000'},
        //     {value: 'G2500', name: 'Glo Data 7.7GB – 30 Days', price: '2480', appr: '2500'},
        //     {value: 'G3000', name: 'Glo Data 10GB – 30 Days', price: '2980', appr: '3000'},
        //     {value: 'G4000', name: 'Glo Data 13.25GB – 30 Days', price: '3900', appr: '4000'},
        //     {value: 'G5000', name: 'Glo Data 18.25GB – 30 Days', price: '4900', appr: '5000'},
        //     {value: 'G8000', name: 'Glo Data 29.5GB – 30 Days', price: '7900', appr: '8000'},
        //     {value: 'glo10000', name: 'Glo Data 50GB – 30 Days', price: '9900', appr: '10000'},
        //   ];
        // }else if(this.data.network == "airtel"){
        //   this.dataPlans = [
        //     {value: 'airt-500', name: 'Airtel Data 750MB – 14 Days', price: '500', appr: null},
        //     {value: 'airt-300x', name: 'Airtel Data 1GB – 1 Day', price: '300', appr: null},
        //     {value: 'AIR1000', name: 'Airtel Data 1.5GB – 30 Days', price: '995', appr: '1000'},
        //     {value: 'airt-500x', name: 'Airtel Data 2GB – 2 Days', price: '500', appr: null},
        //     {value: 'airt-1200', name: 'Airtel Data 2GB – 30 Days', price: '1190', appr: '2000'},
        //     {value: 'Air1500', name: 'Airtel Data 3GB – 30 Days', price: '1500', appr: null},
        //     {value: 'AIR2000', name: 'Airtel Data 4.5GB – 30 Days', price: '1990', appr: '2000'},
        //     {value: 'airt-1500-2', name: 'Airtel Data 6GB – 7 Days', price: '1500', appr: null},
        //     {value: 'Air3000', name: 'Airtel Data 10GB – 30 Days', price: '2990', appr: '3000'},
        //     {value: 'Air5000', name: 'Airtel Data 20GB – 30 Days', price: '4950', appr: '5000'},
        //     {value: 'Air100000', name: 'Airtel Data 40GB – 30 Days', price: '9900', appr: '10000'},
        //   ];
        // }else if(this.data.network == "etisalat"){
        //   this.dataPlans = [
        //     {value: '9MOB1000', name: '9mobile Data 1GB – 30 Days', price: '995', appr: '1000'},
        //     {value: '9MOB34500', name: '9mobile Data 2.5GB – 30 Days', price: '1990', appr: '2000'},
        //     {value: '9MOB8000', name: '9mobile Data 11.5GB – 30 Days', price: '7990', appr: '8000'},
        //     {value: '9MOB5000', name: '9mobile Data 15GB – 30 Days', price: '9900', appr: '10000'},
        //   ];
        // }else{
        //   this.dataPlans = [];
        // }
      },
      checkCPChoice(){
        let info = {'provider': this.cable.provider};
        this.isLoadingFDataBundles = true;
        axios.post(this.nodeurl + "fetch-cable-bundles", info).then(message => {
          this.isLoadingFDataBundles = false;
          this.cablePlans = message.data.message.plans;
          // console.log(this.cablePlans)
        }).catch(err => {
          this.isLoadingFDataBundles = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
        // if(this.cable.provider == "dstv"){
        //   this.cablePlans = [
        //     {value: 'dstv-padi', name: 'DStv Padi', price: '2150'},
        //     {value: 'dstv-yanga', name: 'DStv Yanga', price: '2950'},
        //     {value: 'dstv-confam', name: ' DStv Confam', price: '5300'},
        //     {value: 'dstv6', name: 'DStv Asian', price: '7100'},
        //     {value: 'dstv79', name: 'DStv Compact', price: '9000'},
        //     {value: 'dstv7', name: 'DStv Compact Plus', price: '14250'},
        //     {value: 'dstv3', name: 'DStv Premium', price: '21000'},
        //     {value: 'dstv10', name: 'DStv Premium Asia', price: '23500'},
        //     {value: 'dstv9', name: 'DStv Premium-French', price: '29300'},
        //     {value: 'confam-extra', name: 'DStv Confam + ExtraView', price: '8200'},
        //     {value: 'yanga-extra', name: 'DStv Yanga + ExtraView', price: '5850'},
        //     {value: 'padi-extra', name: 'DStv Padi + ExtraView', price: '5050'},
        //     {value: 'com-asia', name: 'DStv Compact + Asia', price: '16100'},
        //     {value: 'dstv30', name: 'DStv Compact + Extra View', price: '11900'},
        //     {value: 'com-frenchtouch', name: 'DStv Compact + French Touch', price: '11650'},
        //     {value: 'dstv33', name: 'DStv Premium – Extra View', price: '23900'},
        //     {value: 'dstv40', name: 'DStv Compact Plus – Asia', price: '21350'},
        //     {value: 'com-frenchtouch-extra', name: 'DStv Compact + French Touch + ExtraView', price: '14550'},
        //     {value: 'com-asia-extra', name: 'DStv Compact + Asia + ExtraView', price: '19000'},
        //     {value: 'dstv43', name: 'DStv Compact Plus + French Plus', price: '23550'},
        //     {value: 'complus-frenchtouch', name: 'DStv Compact Plus + French Touch', price: '16900'},
        //     {value: 'dstv45', name: 'DStv Compact Plus – Extra View', price: '17150'},
        //     {value: 'complus-french-extraview', name: 'DStv Compact Plus + FrenchPlus + Extra View', price: '26450'},
        //     {value: 'dstv47', name: 'DStv Compact + French Plus', price: '18300'},
        //     {value: 'dstv48', name: 'DStv Compact Plus + Asia + ExtraView', price: '24250'},
        //     {value: 'dstv61', name: 'DStv Premium + Asia + Extra View', price: '31000'},
        //     {value: 'dstv62', name: 'DStv Premium + French + Extra View', price: '32200'},
        //     {value: 'hdpvr-access-service', name: 'DStv HDPVR Access Service', price: '2900'},
        //     {value: 'frenchplus-addon', name: 'DStv French Plus Add-on', price: '9300'},
        //     {value: 'asia-addon', name: 'DStv Asian Add-on', price: '7100'},
        //     {value: 'frenchtouch-addon', name: 'DStv French Touch Add-on', price: '2650'},
        //     {value: 'extraview-access', name: 'ExtraView Access', price: '2900'},
        //     {value: 'french11', name: 'DStv French 11', price: '4100'},
        //   ];
        // }else if(this.cable.provider == "gotv"){
        //   this.cablePlans = [
        //     {value: 'gotv-smallie', name: 'GOtv Smallie', price: '900'},
        //     {value: 'gotv-jinja', name: 'GOtv Jinja', price: '1900'},
        //     {value: 'gotv-jolli', name: 'GOtv Jolli', price: '2800'},
        //     {value: 'gotv-max', name: 'GOtv Max', price: '4150'},
        //     {value: 'gotv-supa', name: 'GOtv Supa', price: '5500'},
        //   ];
        // }else if(this.cable.provider == "startimes"){
        //   this.cablePlans = [
        //     {value: 'nova', name: 'Startimes Nova', price: '900'},
        //     {value: 'basic', name: 'Startimes Basic', price: '1700'},
        //     {value: 'smart', name: 'Startimes Smart', price: '2200'},
        //     {value: 'classic', name: 'Startimes Classic', price: '2500'},
        //     {value: 'super', name: 'Startimes Super', price: '4200'},
        //   ];
        // }else{
        //   this.cablePlans = [];
        // }
      },
      signAirtime(){
        this.isLoading = true;
        let new_trans = {};

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = parseFloat(this.airtime.percAmount).toFixed(2);

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "AIRTIME";
        newTransaction.bill_vendor = this.airtime.network;
        newTransaction.amount = parseFloat(this.airtime.percAmount).toFixed(2);

        let info = {
          to: '0' + this.airtime.phone,
          network: this.airtime.network,
          amount: parseInt(this.airtime.amount),
        }

        let receiverDetails = {};
        receiverDetails.id = this.profile_id;
        receiverDetails.user_id = this.user_id;
        receiverDetails.amount = parseFloat(this.airtime.percAmount).toFixed(2);

        new_trans.senderDetails = senderDetails;
        new_trans.receiverDetails = receiverDetails;
        new_trans.newTransaction = newTransaction;
        new_trans.info = info;

        let count = 1;

        let new_app = {};
        new_app.appr_type = "BILL";
        new_app.details = JSON.stringify(new_trans);
        new_app.business = this.user_id;

        axios.post(this.url + "api/v1/create-n-approval/", new_app,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.signatories.forEach(element => {
            new_app.signatory = element.signatory.id;
            new_app.business = element.business.id;
            new_app.approval = response.data.id;
            axios.post(this.url + "api/v1/create-approval/", new_app,
            { headers: { authorization: "Token " + this.token } }).then(response => {
              if(this.signatories.length == count){
                this.isLoading = false;
                router.push("/approvals");
                this.$toast.info('Transaction Initiated. Awaiting Validation.', {duration: 3000, position: "top-right"});
              }else{
                count++;
              }
            }).catch(err => {
              this.isLoading = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          });
        }).catch(err => {
          this.isLoading = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      buyAirtime(){
        this.isLoading = true;
        this.isDisabled = true;

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = parseFloat(this.airtime.percAmount).toFixed(2);
        senderDetails.amtt2 = parseInt(this.airtime.amount);
        senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "AIRTIME";
        newTransaction.bill_vendor = this.airtime.network;
        newTransaction.amount = parseFloat(this.airtime.percAmount).toFixed(2);

        let encData = this.CryptoJS.AES.encrypt(JSON.stringify(senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

        let info = {
          to: '0' + this.airtime.phone,
          network: this.airtime.network,
          // amount: parseInt(this.airtime.amount),
          token: this.token,
          senderDetails: encData,
          newTransaction: newTransaction
        }

        // newTransaction.balance_after_trans_sender = response.data.balance;

        axios.post(this.nodeurl + "new-airtime2", info).then(message => {
          this.isLoading = false;
          this.isDisabled = false;
          this.$toast.success('Airtime Successfully Purchased.', {duration: 3000, position: "top-right"});
          router.push("/");
        }).catch(err => {
          if(err.response){
            let rn = parseInt(localStorage.getItem('rn')) + 1;
            this.isLoading = false;
            this.isDisabled = false;
            this.isLoadingConPayWB = false;
            localStorage.setItem('rn', rn);
          }

          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });

      },
      signData(){
        let self = this;
        this.isLoading = true;
        let new_trans = {};

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = this.data.variation_id.price;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "DATA";
        newTransaction.bill_vendor = this.data.network;
        newTransaction.amount = this.data.variation_id.price;

        let info = {
          to: '0' + this.data.phone,
          network: this.data.network,
          variation_id: this.data.variation_id.value,
        }

        let receiverDetails = {};
        receiverDetails.id = this.profile_id;
        receiverDetails.user_id = this.user_id;
        receiverDetails.amount = this.data.variation_id.price;

        new_trans.senderDetails = senderDetails;
        new_trans.receiverDetails = receiverDetails;
        new_trans.newTransaction = newTransaction;
        new_trans.info = info;

        let count = 1;

        let new_app = {};
        new_app.appr_type = "BILL";
        new_app.details = JSON.stringify(new_trans);
        new_app.business = this.user_id;

        axios.post(this.url + "api/v1/create-n-approval/", new_app,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.signatories.forEach(element => {
            new_app.signatory = element.signatory.id;
            new_app.business = element.business.id;
            new_app.approval = response.data.id;
            axios.post(this.url + "api/v1/create-approval/", new_app,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              if(this.signatories.length == count){
                this.isLoading = false;
                router.push("/approvals");
                this.$toast.info('Transaction Initiated. Awaiting Validation.', {duration: 3000, position: "top-right"});
              }else{
                count++;
              }
            }).catch(err => {
              this.isLoading = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          });
        }).catch(err => {
          this.isLoading = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      fetchDataProviders(){
        let info = {};
        this.isLoadingFData = true;
        axios.post(this.nodeurl + "fetch-data-providers", info).then(message => {
          this.isLoadingFData = false;
          this.dataProviders = message.data.message.billers;
        }).catch(err => {
          this.isLoadingFData = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      buyData(){
        this.isLoading = true;
        this.isDisabled = true;

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = this.data.variation_id.price - (this.data.variation_id.price * 0.01);
        senderDetails.variation_id = this.data.variation_id.code,
        senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "DATA";
        newTransaction.bill_vendor = this.data.network.name;
        newTransaction.amount = this.data.variation_id.price - (this.data.variation_id.price * 0.01);

        let encData = this.CryptoJS.AES.encrypt(JSON.stringify(senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

        let info = {
          to: '0' + this.data.phone,
          network: this.data.network,
          token: this.token,
          senderDetails: encData,
          newTransaction: newTransaction
        }

        axios.post(this.nodeurl + "new-data2", info).then(message => {
            this.isLoading = false;
            this.isDisabled = false;
            this.isLoadingConPayWB = false;
            this.$toast.success('Data Successfully Purchased.', {duration: 3000, position: "top-right"});
            router.push("/");
        }).catch(err => {
          if(err.response){
            this.isLoading = false;
            this.isDisabled = false;
            this.isLoadingConPayWB = false;
            let rn = parseInt(localStorage.getItem('rn')) + 1;
            localStorage.setItem('rn', rn);
          }

          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });

      },
      fetchSMEPlans(){
        let info = {};
        this.isLoadingFDataBundles = true;
        axios.post(this.nodeurl + "fetch-sme-bundles", info).then(message => {
          this.isLoadingFDataBundles = false;
          // console.log(message.data)
          this.dataPlans = message.data.message.data;
        }).catch(err => {
          this.isLoadingFDataBundles = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      buySMEData(){
        this.isLoading = true;
        this.isDisabled = true;

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        if(this.data.variation_id.description == 'SME DATA 500MB'){
          senderDetails.amount = 200.00;
        }else if(this.data.variation_id.description == 'SME DATA 1GB'){
          senderDetails.amount = 400.00;
        }else if(this.data.variation_id.description == 'SME DATA 2GB'){
          senderDetails.amount = 650.00;
        }else if(this.data.variation_id.description == 'SME DATA 3GB'){
          senderDetails.amount = 850.00;
        }else if(this.data.variation_id.description == 'SME DATA 5GB'){
          senderDetails.amount = 1500.00;
        }else if(this.data.variation_id.description == 'SME DATA 10GB'){
          senderDetails.amount = 2800.00;
        }
        senderDetails.variation_id = this.data.variation_id.code,
        senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "DATA";
        newTransaction.bill_vendor = 'MTN';
        if(this.data.variation_id.description == 'SME DATA 500MB'){
          newTransaction.amount = 200.00;
        }else if(this.data.variation_id.description == 'SME DATA 1GB'){
          newTransaction.amount = 400.00;
        }else if(this.data.variation_id.description == 'SME DATA 2GB'){
          newTransaction.amount = 650.00;
        }else if(this.data.variation_id.description == 'SME DATA 3GB'){
          newTransaction.amount = 850.00;
        }else if(this.data.variation_id.description == 'SME DATA 5GB'){
          newTransaction.amount = 1500.00;
        }else if(this.data.variation_id.description == 'SME DATA 10GB'){
          newTransaction.amount = 2800.00;
        }

        let encData = this.CryptoJS.AES.encrypt(JSON.stringify(senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

        let info = {
          to: '0' + this.data.phone,
          network: this.data.network,
          token: this.token,
          senderDetails: encData,
          newTransaction: newTransaction
        }

        axios.post(this.nodeurl + "sme-data2", info).then(message => {
            this.isLoading = false;
            this.isDisabled = false;
            this.isLoadingConPayWB = false;
            this.$toast.success('Data Successfully Purchased.', {duration: 3000, position: "top-right"});
            router.push("/");
        }).catch(err => {
          if(err.response){
            this.isLoading = false;
            this.isDisabled = false;
            this.isLoadingConPayWB = false;
            let rn = parseInt(localStorage.getItem('rn')) + 1;
            localStorage.setItem('rn', rn);
          }

          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });

      },
      fetchSpectranetPinPlans(){
        let info = {};
        this.isLoadingFDataBundles = true;
        axios.post(this.nodeurl + "fetch-spectranet-pins", info).then(message => {
          this.isLoadingFDataBundles = false;
          console.log(message.data)
          this.dataPlans = message.data.message.data;
        }).catch(err => {
          this.isLoadingFDataBundles = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      buySpectranetPin(){
        this.isLoading = true;
        this.isDisabled = true;

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = this.data.variation_id.amount;
        senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "DATA";
        newTransaction.bill_vendor = 'MTN';
        if(this.data.variation_id.description == 'SME DATA 500MB'){
          newTransaction.amount = 200.00;
        }else if(this.data.variation_id.description == 'SME DATA 1GB'){
          newTransaction.amount = 400.00;
        }else if(this.data.variation_id.description == 'SME DATA 2GB'){
          newTransaction.amount = 650.00;
        }else if(this.data.variation_id.description == 'SME DATA 3GB'){
          newTransaction.amount = 850.00;
        }else if(this.data.variation_id.description == 'SME DATA 5GB'){
          newTransaction.amount = 1500.00;
        }else if(this.data.variation_id.description == 'SME DATA 10GB'){
          newTransaction.amount = 2800.00;
        }

        let encData = this.CryptoJS.AES.encrypt(JSON.stringify(senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

        let info = {
          to: '0' + this.data.phone,
          network: this.data.network,
          token: this.token,
          senderDetails: encData,
          newTransaction: newTransaction
        }

        axios.post(this.nodeurl + "sme-data2", info).then(message => {
            this.isLoading = false;
            this.isDisabled = false;
            this.isLoadingConPayWB = false;
            this.$toast.success('Data Successfully Purchased.', {duration: 3000, position: "top-right"});
            router.push("/");
        }).catch(err => {
          if(err.response){
            this.isLoading = false;
            this.isDisabled = false;
            this.isLoadingConPayWB = false;
            let rn = parseInt(localStorage.getItem('rn')) + 1;
            localStorage.setItem('rn', rn);
          }

          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });

      },
      fetchSmilePlans(){
        let info = {};
        this.isLoadingFDataBundles = true;
        axios.post(this.nodeurl + "fetch-smile-bundles", info).then(message => {
          this.isLoadingFDataBundles = false;
          // console.log(message.data)
          this.dataPlans = message.data.message.data;
        }).catch(err => {
          this.isLoadingFDataBundles = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      buySmileData(){
        this.isLoading = true;
        this.isDisabled = true;

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = this.data.variation_id.amount - (this.data.variation_id.amount * 0.01);
        senderDetails.variation_id = this.data.variation_id.code,
        senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "DATA";
        newTransaction.bill_vendor = 'SMILE';
        newTransaction.amount = this.data.variation_id.amount - (this.data.variation_id.amount * 0.01);

        let encData = this.CryptoJS.AES.encrypt(JSON.stringify(senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

        let info = {
          to: '0' + this.data.phone,
          network: 'SMILE',
          token: this.token,
          senderDetails: encData,
          newTransaction: newTransaction
        }

        axios.post(this.nodeurl + "smile-data2", info).then(message => {
            this.isLoading = false;
            this.isDisabled = false;
            this.isLoadingConPayWB = false;
            this.$toast.success('Data Successfully Purchased.', {duration: 3000, position: "top-right"});
            router.push("/");
        }).catch(err => {
          if(err.response){
            this.isLoading = false;
            this.isDisabled = false;
            this.isLoadingConPayWB = false;
            let rn = parseInt(localStorage.getItem('rn')) + 1;
            localStorage.setItem('rn', rn);
          }

          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });

      },
      fetchCableProviders(){
        let info = {};
        this.isLoadingFData = true;
        axios.post(this.nodeurl + "fetch-cable-providers", info).then(message => {
          this.isLoadingFData = false;
          // console.log(message.data);
          this.cableProviders = message.data.message.billers;
        }).catch(err => {
          this.isLoadingFData = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      signCable(){
        let self = this;
        this.isLoading = true;
        let new_trans = {};

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = this.cable.plan.price;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "CABLE";
        newTransaction.bill_vendor = this.cable.provider;
        newTransaction.amount = this.cable.plan.price;

        let info = {
          to: '0' + this.cable.phone,
          service_id: this.cable.provider,
          smartcard_number: this.cable.smartcard_number,
          variation_id: this.cable.plan.value,
        }

        let receiverDetails = {};
        receiverDetails.id = this.user_id;
        receiverDetails.user_id = this.user_id;
        receiverDetails.amount = this.cable.plan.price;

        new_trans.senderDetails = senderDetails;
        new_trans.receiverDetails = receiverDetails;
        new_trans.newTransaction = newTransaction;
        new_trans.info = info;

        let count = 1;

        let new_app = {};
        new_app.appr_type = "BILL";
        new_app.details = JSON.stringify(new_trans);
        new_app.business = this.user_id;

        axios.post(this.url + "api/v1/create-n-approval/", new_app,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.signatories.forEach(element => {
            new_app.signatory = element.signatory.id;
            new_app.business = element.business.id;
            new_app.approval = response.data.id;
            axios.post(this.url + "api/v1/create-approval/", new_app,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              if(this.signatories.length == count){
                this.isLoading = false;
                router.push("/approvals");
                this.$toast.info('Transaction Initiated. Awaiting Validation.', {duration: 3000, position: "top-right"});
              }else{
                count++;
              }
            }).catch(err => {
              this.isLoading = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          });
        }).catch(err => {
          this.isLoading = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      buyCable(){
        this.isLoading = true;
        this.isDisabled = true;

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = this.cable.plan.price;
        senderDetails.variation_id = this.cable.plan.code,
        senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "CABLE";
        newTransaction.bill_vendor = this.cable.provider.name;
        newTransaction.amount = this.cable.plan.price;

        let encData = this.CryptoJS.AES.encrypt(JSON.stringify(senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

        let info = {
          to: '0' + this.cable.phone,
          service_id: this.cable.provider.type,
          smartcard_number: this.cable.smartcard_number,
          // variation_id: this.cable.plan.value,
          token: this.token,
          senderDetails: encData,
          newTransaction: newTransaction
        }

        axios.post(this.nodeurl + "new-cable2", info).then(message => {
          // newTransaction.token = message.data.token;
          this.isLoading = false;
          this.isDisabled = false;
          this.isLoadingConPayWB = false;
          this.$toast.success('Cable Successfully Subscribed.', {duration: 3000, position: "top-right"});
          router.push("/");
        }).catch(err => {
          if(err.response){
            this.isLoading = false;
            this.isDisabled = false;
            this.isLoadingConPayWB = false;
            let rn = parseInt(localStorage.getItem('rn')) + 1;
            localStorage.setItem('rn', rn);
          }

          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      fetchElectricityProviders(){
        let info = {};
        this.isLoadingFData = true;
        axios.post(this.nodeurl + "fetch-elec-providers", info).then(message => {
          this.isLoadingFData = false;
          // console.log(message.data);
          this.elecProviders = message.data.message.billers;
        }).catch(err => {
          this.isLoadingFData = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      signElec(){
        let self = this;
        this.isLoading = true;
        let new_trans = {};

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = this.elec.amount;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "ELECTRICITY";
        newTransaction.bill_vendor = this.cable.provider;
        newTransaction.amount = this.elec.amount;

        let info = {
          to: '0' + this.elec.phone,
          service_id: this.elec.provider,
          meter_number: this.elec.meter_number,
          variation_id: 'prepaid',
          amount: this.elec.amount,
        }

        let receiverDetails = {};
        receiverDetails.id = this.profile_id;
        receiverDetails.user_id = this.user_id;
        receiverDetails.amount = this.elec.amount;

        new_trans.senderDetails = senderDetails;
        new_trans.receiverDetails = receiverDetails;
        new_trans.newTransaction = newTransaction;
        new_trans.info = info;

        let count = 1;

        let new_app = {};
        new_app.appr_type = "BILL";
        new_app.details = JSON.stringify(new_trans);
        new_app.business = this.user_id;

        axios.post(this.url + "api/v1/create-n-approval/", new_app,
        { headers: { authorization: "Token " + self.token } }).then(response => {
          this.signatories.forEach(element => {
            new_app.signatory = element.signatory.id;
            new_app.business = element.business.id;
            new_app.approval = response.data.id;
            axios.post(this.url + "api/v1/create-approval/", new_app,
            { headers: { authorization: "Token " + self.token } }).then(response => {
              if(this.signatories.length == count){
                this.isLoading = false;
                router.push("/approvals");
                this.$toast.info('Transaction Initiated. Awaiting Validation.', {duration: 3000, position: "top-right"});
              }else{
                count++;
              }
            }).catch(err => {
              this.isLoading = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
          });
        }).catch(err => {
          this.isLoading = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      buyElec(){
        this.isLoading = true;
        this.isDisabled = true;

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = this.elec.amount;
        senderDetails.variation_id = 'prepaid',
        senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "ELECTRICITY";
        newTransaction.bill_vendor = this.elec.provider.short_name.toUpperCase();
        newTransaction.amount = this.elec.amount;

        let encData = this.CryptoJS.AES.encrypt(JSON.stringify(senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

        let info = {
          to: '0' + this.elec.phone,
          service_id: this.elec.provider.type,
          meter_number: this.elec.meter_number,
          token: this.token,
          senderDetails: encData,
          newTransaction: newTransaction
        }

        axios.post(this.nodeurl + "new-elec2", info).then(message => {
          // console.log(message);
          // console.log(message.data.message.data.token);
          // newTransaction.token = message.data.message.data.token;
          this.isLoading = false;
          this.isDisabled = false;
          this.isLoadingConPayWB = false;
          this.$toast.success('Successfully Paid for Electricity. Your token can be found in transactions and a text has been sent to your phone number', {duration: 6000, position: "top-right"});
          router.push("/");
        }).catch(err => {
          let rn = parseInt(localStorage.getItem('rn')) + 1;
          localStorage.setItem('rn', rn);
          this.isLoading = false;
          this.isDisabled = false;
          this.isLoadingConPayWB = false;

          if(err.response){
            // console.log(err.response.data.message)
            if(err.response.data.message.message == "Incorrect meter number. Please try with a correct one"){
              this.$toast.error(err.response.data.message.message, {duration: 3000, position: "top-right"});
            }else{
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            }
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
          
        });

      },
      fetchWaecPlans(){
        let info = {};
        this.isLoadingFData = true;
        axios.post(this.nodeurl + "fetch-waec-plans", info).then(message => {
          this.isLoadingFData = false;
          // console.log(message.data);
          this.waecPlans = message.data.message.data.product;
        }).catch(err => {
          this.isLoadingFData = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      buyWaec(){
        this.isLoading = true;
        this.isDisabled = true;

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = this.waec.plan.price;
        senderDetails.variation_id = this.waec.numberOfPin;
        senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "WAEC";
        newTransaction.bill_vendor = "WAEC";
        newTransaction.amount = this.waec.plan.price;

        let encData = this.CryptoJS.AES.encrypt(JSON.stringify(senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

        let info = {
          token: this.token,
          senderDetails: encData,
          newTransaction: newTransaction
        }

        axios.post(this.nodeurl + "new-waec2", info).then(message => {
          // console.log(message);
          // console.log(message.data.message.data.token);
          // newTransaction.token = message.data.message.data.token;
          this.isLoading = false;
          this.isDisabled = false;
          this.isLoadingConPayWB = false;
          this.$toast.success('Successfully Paid for WAEC PIN. Your PIN(s) can be found in transactions', {duration: 6000, position: "top-right"});
          router.push("/");
        }).catch(err => {
          let rn = parseInt(localStorage.getItem('rn')) + 1;
          localStorage.setItem('rn', rn);
          this.isLoading = false;
          this.isDisabled = false;
          this.isLoadingConPayWB = false;

          if(err.response){
            // console.log(err.response.data.message)
            if(err.response.data.message.message == "Incorrect meter number. Please try with a correct one"){
              this.$toast.error(err.response.data.message.message, {duration: 3000, position: "top-right"});
            }else{
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            }
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
          
        });
      },
      fetchJambPlans(){
        let info = {};
        this.isLoadingFData = true;
        axios.post(this.nodeurl + "fetch-jamb-plans", info).then(message => {
          this.isLoadingFData = false;
          // console.log(message.data.message.data);
          this.jambPlans = message.data.message.data;
        }).catch(err => {
          this.isLoadingFData = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        });
      },
      buyJamb(){
        this.isLoading = true;
        this.isDisabled = true;

        let senderDetails = {};
        senderDetails.id = this.profile_id;
        senderDetails.user_id = this.user_id;
        senderDetails.amount = this.jamb.plan.price;
        senderDetails.variation_id = this.jamb.plan.type;
        senderDetails.profileCode = this.jamb.profileCode;
        senderDetails.phoneNumber = this.jamb.phone;
        senderDetails.rn = parseInt(localStorage.getItem('rn')) + 1;

        let newTransaction = {};
        newTransaction.sender = this.user_id;
        newTransaction.trans_type = "JAMB";
        newTransaction.bill_vendor = "JAMB";
        newTransaction.amount = this.jamb.plan.price;

        let encData = this.CryptoJS.AES.encrypt(JSON.stringify(senderDetails), process.env.VUE_APP_SECRET_QR_PASSWORD).toString();

        let info = {
          token: this.token,
          senderDetails: encData,
          newTransaction: newTransaction
        }

        axios.post(this.nodeurl + "new-jamb2", info).then(message => {
          // console.log(message);
          // console.log(message.data.message.data.token);
          // newTransaction.token = message.data.message.data.token;
          this.isLoading = false;
          this.isDisabled = false;
          this.isLoadingConPayWB = false;
          this.$toast.success('Successfully Paid for Electricity. Your token can be found in transactions and a text has been sent to your phone number', {duration: 6000, position: "top-right"});
          router.push("/");
        }).catch(err => {
          let rn = parseInt(localStorage.getItem('rn')) + 1;
          localStorage.setItem('rn', rn);
          this.isLoading = false;
          this.isDisabled = false;
          this.isLoadingConPayWB = false;

          if(err.response){
            // console.log(err.response.data.message)
            if(err.response.data.message.message == "Incorrect meter number. Please try with a correct one"){
              this.$toast.error(err.response.data.message.message, {duration: 3000, position: "top-right"});
            }else{
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            }
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
          
        });
      },
      checkPin(){
        if(this.mainRecData.profile != null){
          this.$modal.show('pin2BModal');
        }else{
          this.$toast.error('Please choose a recepient.', {duration: 3000, position: "top-right"})
        }
      },
      camcelTipStaff(){
        this.mainRecData = {};
        this.staffRecData = {};
        this.$modal.hide("tip2QModal");
      },
      checkPinAirtime(){
        // console.log(this.pinCode)
        this.isLoadingConPayWB = true;
        this.isDisabled = true;

        let check_pinn = {};
        check_pinn.pin = this.pinCode;

        axios.put(this.url + "api/v1/check-pin/" + this.profile_id + "/", check_pinn,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.buyAirtime();
        }).catch(err => {
          // console.log(err.response)
          this.isLoadingConPayWB = false;
          this.isDisabled = false;
          if(err.response){
            this.$toast.error('Error. Invalid Code', {duration: 3000, position: "top-right"});
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
        });
      },
      checkPinData(){
        // console.log(this.pinCode)
        this.isLoadingConPayWB = true;
        this.isDisabled = true;

        let check_pinn = {};
        check_pinn.pin = this.pinCode;

        axios.put(this.url + "api/v1/check-pin/" + this.profile_id + "/", check_pinn,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.buyData();
        }).catch(err => {
          // console.log(err.response)
          this.isLoadingConPayWB = false;
          this.isDisabled = false;
          if(err.response){
            this.$toast.error('Error. Invalid Code', {duration: 3000, position: "top-right"});
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
        });
      },
      checkPinSME(){
        // console.log(this.pinCode)
        this.isLoadingConPayWB = true;
        this.isDisabled = true;

        let check_pinn = {};
        check_pinn.pin = this.pinCode;

        axios.put(this.url + "api/v1/check-pin/" + this.profile_id + "/", check_pinn,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.buySMEData();
        }).catch(err => {
          // console.log(err.response)
          this.isLoadingConPayWB = false;
          this.isDisabled = false;
          if(err.response){
            this.$toast.error('Error. Invalid Code', {duration: 3000, position: "top-right"});
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
        });
      },
      checkPinSmile(){
        this.isLoadingConPayWB = true;
        this.isDisabled = true;

        let check_pinn = {};
        check_pinn.pin = this.pinCode;

        axios.put(this.url + "api/v1/check-pin/" + this.profile_id + "/", check_pinn,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.buySmileData();
        }).catch(err => {
          // console.log(err.response)
          this.isLoadingConPayWB = false;
          this.isDisabled = false;
          if(err.response){
            this.$toast.error('Error. Invalid Code', {duration: 3000, position: "top-right"});
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
        });
      },
      checkPinCable(){
        // console.log(this.pinCode)
        this.isLoadingConPayWB = true;
        this.isDisabled = true;

        let check_pinn = {};
        check_pinn.pin = this.pinCode;

        axios.put(this.url + "api/v1/check-pin/" + this.profile_id + "/", check_pinn,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.buyCable();
        }).catch(err => {
          // console.log(err.response)
          this.isLoadingConPayWB = false;
          this.isDisabled = false;
          if(err.response){
            this.$toast.error('Error. Invalid Code', {duration: 3000, position: "top-right"});
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
        });
      },
      checkPinElec(){
        // console.log(this.pinCode)
        this.isLoadingConPayWB = true;
        this.isDisabled = true;

        let check_pinn = {};
        check_pinn.pin = this.pinCode;

        axios.put(this.url + "api/v1/check-pin/" + this.profile_id + "/", check_pinn,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.buyElec();
        }).catch(err => {
          // console.log(err.response)
          this.isLoadingConPayWB = false;
          this.isDisabled = false;
          if(err.response){
            this.$toast.error('Error. Invalid Code', {duration: 3000, position: "top-right"});
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
        });
      },
      checkPinWaec(){
        this.isLoadingConPayWB = true;
        this.isDisabled = true;

        let check_pinn = {};
        check_pinn.pin = this.pinCode;

        axios.put(this.url + "api/v1/check-pin/" + this.profile_id + "/", check_pinn,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.buyWaec();
        }).catch(err => {
          // console.log(err.response)
          this.isLoadingConPayWB = false;
          this.isDisabled = false;
          if(err.response){
            this.$toast.error('Error. Invalid Code', {duration: 3000, position: "top-right"});
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
        });
      },
      checkPinJamb(){
        this.isLoadingConPayWB = true;
        this.isDisabled = true;

        let check_pinn = {};
        check_pinn.pin = this.pinCode;

        axios.put(this.url + "api/v1/check-pin/" + this.profile_id + "/", check_pinn,
        { headers: { authorization: "Token " + this.token } }).then(response => {
          this.buyJamb();
        }).catch(err => {
          // console.log(err.response)
          this.isLoadingConPayWB = false;
          this.isDisabled = false;
          if(err.response){
            this.$toast.error('Error. Invalid Code', {duration: 3000, position: "top-right"});
          }else{
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          }
        });
      },
      openPinAirtimeModal(){
        if(this.airtime.network == null || this.airtime.network == '' || this.airtime.network == ' '){
          this.$toast.error('Error. Kindly Choose a Network Provider.', {duration: 3000, position: "top-right"})
        }else if(this.airtime.amount < 50){
          this.$toast.error('Error. You can only buy airtime of ₦50 and above', {duration: 3000, position: "top-right"})
        }else{
          if(this.has_signatory == 'false'){
            this.$modal.show('pinAirtimeModal');
          }else{
            this.signAirtime();
          }
        }
      },
      openPinDataModal(){
        if(this.data.network == null || this.data.network == '' || this.data.network == ' ' ||
        this.data.variation_id == null || this.data.variation_id == '' || this.data.variation_id == ' '){
          this.$toast.error('Error. Kindly Fill All Fields.', {duration: 3000, position: "top-right"})
        }else{
          if(this.has_signatory == 'false'){
            this.$modal.show('pinDataModal');
          }else{
            this.signData();	
          }
        }
      },
      openPinSMEModal(){
        if(this.data.variation_id == null || this.data.variation_id == '' || this.data.variation_id == ' '){
          this.$toast.error('Error. Kindly Fill All Fields.', {duration: 3000, position: "top-right"})
        }else{
          if(this.has_signatory == 'false'){
            this.$modal.show('pinSMEModal');
          }else{
            this.signSME();	
          }
        }
      },
      openPinSmileModal(){
        if(this.data.variation_id == null || this.data.variation_id == '' || this.data.variation_id == ' '){
          this.$toast.error('Error. Kindly Fill All Fields.', {duration: 3000, position: "top-right"})
        }else{
          if(this.has_signatory == 'false'){
            this.$modal.show('pinSmileModal');
          }else{
            this.signSmile();	
          }
        }
      },
      openPinCableModal(){
        if(this.cable.provider == null || this.cable.provider == '' || this.cable.provider == ' ' ||
        this.cable.plan == null || this.cable.plan == '' || this.cable.plan == ' '){
          this.$toast.error('Error. Kindly Fill All Fields.', {duration: 3000, position: "top-right"})
        }else{
          if(this.has_signatory == 'false'){
            this.$modal.show('pinCableModal');
          }else{
            this.signCable();
          }
        }
      },
      openPinElecModal(){
        if(this.elec.provider == null || this.elec.provider == '' || this.elec.provider == ' '){
          this.$toast.error('Error. Kindly Fill All Fields.', {duration: 3000, position: "top-right"})
        }else if(this.elec.amount < 500){

        }else{
          if(this.has_signatory == 'false'){
            this.$modal.show('pinElecModal');
          }else{
            this.signElec();
          }
        }
      },
      openPinWaecModal(){
        if(this.waec.plan == null || this.waec.plan == '' || this.waec.plan == ' '){
          this.$toast.error('Error. Kindly Fill All Fields.', {duration: 3000, position: "top-right"})
        }else{
          if(this.has_signatory == 'false'){
            this.$modal.show('pinWaecModal');
          }else{
            this.signWaec();
          }
        }
      },
      openPinJambModal(){
        if(this.jamb.plan == null || this.jamb.plan == '' || this.jamb.plan == ' '){
          this.$toast.error('Error. Kindly Fill All Fields.', {duration: 3000, position: "top-right"})
        }else{
          if(this.has_signatory == 'false'){
            this.$modal.show('pinJambModal');
          }else{
            this.signJamb();
          }
        }
      },
      closePinAirtimeModal(){
        this.pinCode = '';
        this.$modal.hide('pinAirtimeModal');
      },
      closePinDataModal(){
        this.pinCode = '';
        this.$modal.hide('pinDataModal');
      },
      closePinSMEModal(){
        this.pinCode = '';
        this.$modal.hide('pinSMEModal');
      },
      closePinSmileModal(){
        this.pinCode = '';
        this.$modal.hide('pinSmileModal');
      },
      closePinCableModal(){
        this.pinCode = '';
        this.$modal.hide('pinCableModal');
      },
      closePinElecModal(){
        this.pinCode = '';
        this.$modal.hide('pinElecModal');
      },
      closePinWaecModal(){
        this.pinCode = '';
        this.$modal.hide('pinWaecModal');
      },
      closePinJambModal(){
        this.pinCode = '';
        this.$modal.hide('pinJambModal');
      },
      checkInput(){
        if(this.airtime.amount.toString() == '0'){
          this.airtime.amount = null;
        }else{
          let percAmount = this.airtime.amount * 0.01;
          this.airtime.percAmount = parseFloat(this.airtime.amount).toFixed(2) - parseFloat(percAmount).toFixed(2);
        }
      },
      zoomUpdated (zoom) {
        this.zoom = zoom;
        this.largeRadius = (this.largeRadius * this.zoom) / this.zoomBase;
        this.smallRadius = (this.smallRadius * this.zoom) / this.zoomBase;
      },
    },
  }
</script>

<style lang="css" scoped>
.scrollV{
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    /* align-content: center; */
    height: calc(100vh - 117px);
}

select{
  background: transparent url("data:image/svg+xml;utf8,<svg style='float: right;' width='24' height='24' class='w-6 h-6' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'></path></svg>") no-repeat;
  background-position: right 5px top 50%;
}

.newFl{
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 30px;
  scroll-behavior: smooth;
}

.rowrapper{
  display: flex;
  flex-flow: row wrap;
  justify-content: left;
  align-content: left;
  text-align: left;
  /* padding: 0 100px;  */
  padding-top: .7rem;
  /* background: #2ECC71; */
}

.div1 {
  width: 100%;
  flex: 1 1 25rem;
}

.div2 {
  width: 100%;
  flex: 1 1 25rem;
}

h1, h2, h3, h4, h5, h6 {
    letter-spacing: -.5px;
    line-height: 1.4;
    margin: 5px 0;
    font-weight: 600;
    font-family: "CW BR Firma",sans-serif;
}
h3 {
  font-size: 3rem;
}

h5 {
  font-size: 1.56rem;
}

@media screen and (max-width: 1024px){
  h3 {
    font-size: 1.98rem;
  }
  h5 {
    font-size: 1.4rem;
  }
}

sup{
  vertical-align: middle;
  font-size: .43em;
  font-weight: 400;
  top: -.62em;
}
sub{
    bottom: .05em;
    margin-left: -4px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0;
    opacity: 1;
    font-size: .4em;
}

.qrClass{
  display: flex;
  align-items: center; 
  flex-direction: column;
  margin: 0 auto;
}

.tvv2{
  /* padding-top: 3rem; */
  text-align: center; 
  height: 100%; 
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  scroll-behavior: smooth;  
}

.page{
  box-sizing: border-box;
  background: #ffffff; 
  padding: 2rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 25px 20px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
  /* height: 100%; */
  margin: auto;
  /* padding: 1rem; */

  display: grid;
  grid-gap: 30px;
}

.page2{
  background: transparent; 
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;
  display: grid;
  grid-gap: 30px;
}

.page3{
  background: transparent; 
  width: 100%;
  display: grid;
  grid-gap: 30px;
}

.voucherRow{
  display: flex;
  flex-flow: row wrap;
  align-content: stretch;
  padding: 1rem;
}

.usersRow{
  display: flex;
  flex-flow: row wrap;
  align-content: stretch;
  padding: 1rem;
}

.rS {
  width: 100%;
  /* flex: 1 1 0rem; */
}

.avatar {
  vertical-align: middle;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.field__input{ 
  --uiFieldPlaceholderColor: var(--fieldPlaceholderColor, #767676);
  color: #000000;
  
  background-color: transparent;
  border-radius: 0;
  border: none;

  -webkit-appearance: none;
  -moz-appearance: none;

  font-family: inherit;
  font-size: inherit;
}

.field__input:focus::-webkit-input-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

.field__input:focus::-moz-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

/*
=====
CORE STYLES
=====
*/

.field{
  --uiFieldBorderWidth: var(--fieldBorderWidth, 2px);
  --uiFieldPaddingRight: var(--fieldPaddingRight, 1rem);
  --uiFieldPaddingLeft: var(--fieldPaddingLeft, 1rem);   
  --uiFieldBorderColorActive: var(--fieldBorderColorActive, rgba(22, 22, 22, 1));

  display: var(--fieldDisplay, inline-flex);
  position: relative;
  font-size: var(--fieldFontSize, 1rem);
}

.field__input{
  box-sizing: border-box;
  width: var(--fieldWidth, 100%);
  height: var(--fieldHeight, 3rem);
  padding: var(--fieldPaddingTop, 1.25rem) var(--uiFieldPaddingRight) var(--fieldPaddingBottom, .5rem) var(--uiFieldPaddingLeft);
  border-bottom: var(--uiFieldBorderWidth) solid var(--fieldBorderColor, rgba(0, 0, 0, .25));  
}

.field__input:focus{
  outline: none;
}

.field__input::-webkit-input-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input::-moz-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input:focus::-webkit-input-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__input:focus::-moz-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__label-wrap{
  box-sizing: border-box;
  pointer-events: none;
  cursor: text;
  color: #000000;

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.field__label-wrap::after{
  content: "";
  box-sizing: border-box;
  width: 100%;
  height: 0;
  opacity: 0;

  position: absolute;
  bottom: 0;
  left: 0;
}

.field__input:focus ~ .field__label-wrap::after{
  opacity: 1;
}

.field__label{
  position: absolute;
  left: var(--uiFieldPaddingLeft);
  top: calc(50% - .5em);

  line-height: 1;
  font-size: var(--fieldHintFontSize, inherit);

  transition: top .2s cubic-bezier(0.9, -0.15, 0.1, 1.15), opacity .2s ease-out, font-size .2s ease-out;
  will-change: bottom, opacity, font-size;
}

.field__input:focus ~ .field__label-wrap .field__label,
.field__input:not(:placeholder-shown) ~ .field__label-wrap .field__label{
  --fieldHintFontSize: var(--fieldHintFontSizeFocused, .75rem);

  top: var(--fieldHintTopHover, .25rem);
}

/* 
effect 1
*/

.field_v1 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transition: opacity .2s ease-out;
  will-change: opacity;
}

/* 
effect 2
*/

.field_v2 .field__label-wrap{
  overflow: hidden;
}

.field_v2 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transform: translate3d(-105%, 0, 0);
  will-change: transform, opacity;
  transition: transform .285s ease-out .2s, opacity .2s ease-out .2s;
}

.field_v2 .field__input:focus ~ .field__label-wrap::after{
  transform: translate3d(0, 0, 0);
  transition-delay: 0;
}

/*
effect 3
*/

.field_v3 .field__label-wrap::after{
  border: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  will-change: opacity, height;
  transition: height .2s ease-out, opacity .2s ease-out;
}

.field_v3 .field__input:focus ~ .field__label-wrap::after{
  height: 100%;
}

/*
=====
LEVEL 4. SETTINGS
=====
*/

.field{
  --fieldBorderColor: #ABEBC6;
  --fieldBorderColorActive: #239B56;
}

/*
=====
DEMO
=====
*/

@keyframes placeHolderShimmer {
   0% {
    background: #ececec;
  }
  
  30% {
    background: #F7F7F7;
  }
 
  50% {
    background: #ececec;
  }
  
  80% {
    background: #F7F7F7;
  }
  
  100% {
    background: #ececec;
  }
}

.loading-animation {
  animation: placeHolderShimmer 3s infinite;
}

.view-leave-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
}

.view-enter-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
    transition-delay: 0.2s;
}

.view-enter, .view-leave-to {
    opacity: 0;
}

.view-enter-to, .view-leave {
    opacity: 1;
}

</style>
